import { render, staticRenderFns } from "./data-source-modal.vue?vue&type=template&id=859b327e"
import script from "./data-source-modal.vue?vue&type=script&lang=js"
export * from "./data-source-modal.vue?vue&type=script&lang=js"
import style0 from "./data-source-modal.vue?vue&type=style&index=0&id=859b327e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports